export const BICS_SET_1 = ['USDFLT22XXX'];
